import { useState, useRef, useCallback } from "react";
import { AnimateElement } from "utils/animations";

export function useTableRowAnimation() {
  const [isOpen, setIsOpen] = useState(false);
  const tableRow = useRef<HTMLTableRowElement>(null);
  const internalContainer = useRef<HTMLDivElement>(null);

  const onOpenTableRow = useCallback(() => {
    if (internalContainer.current) {
      const children = internalContainer.current.children[0];
      const childrenHeight = children.clientHeight;
      AnimateElement(
        200,
        [0, 1],
        (progress) => {
          if (tableRow.current && internalContainer.current) {
            const rowStyle = internalContainer.current.style;
            const currentHeight = progress * childrenHeight;
            rowStyle.opacity = `${progress}`;
            rowStyle.height = `${currentHeight}px`;
          }
        },
        () => {
          if (internalContainer.current) {
            internalContainer.current.style.height = `auto`;
            internalContainer.current.style.overflow = "visible";
          }
        }
      );
    }
  }, []);

  const onCloseTableRow = useCallback(() => {
    if (internalContainer.current) {
      const children = internalContainer.current.children[0];
      const childrenHeight = children.clientHeight;
      AnimateElement(
        200,
        [1, 0],
        (progress) => {
          if (tableRow.current && internalContainer.current) {
            const rowStyle = internalContainer.current.style;
            const currentHeight = progress * childrenHeight;
            rowStyle.opacity = `${progress}`;
            rowStyle.height = `${currentHeight}px`;
          }
        },
        () => setIsOpen(false)
      );
    }
  }, []);

  const onToggle = useCallback(
    (refetchOnOpen: () => void) => {
      if (isOpen) {
        onCloseTableRow();
      } else {
        setIsOpen(true);
        refetchOnOpen();
      }
    },
    [isOpen, onCloseTableRow]
  );

  return {
    isOpen,
    tableRow,
    internalContainer,
    onOpenTableRow,
    onCloseTableRow,
    onToggle,
  };
}
